import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { Paths } from '@constants/paths';
import { setRoleIdForDelete } from '@actions/roleActions';
import { setIsOpenRoleDeleteModal } from '@actions/rolesPageActions';
import { canRemoveRoleSelector } from '@selectors/role';
import './index.scss';

const RolesPageAccordionControllersMenu = ({ id: roleId }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const hasPermissionForDeleteRole = useSelector(canRemoveRoleSelector(roleId));

  const handleMenuIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleRemoveOption = () => {
    handleCloseMenu();
    dispatch(setRoleIdForDelete(roleId));
    dispatch(setIsOpenRoleDeleteModal(true));
  };

  return (
    <div className="roles-accordion_controllers-container">
      <IconButton onClick={handleMenuIconClick} data-testid={`accordion-controller-menu-${roleId}`}>
        <MoreVert />
      </IconButton>
      <Menu
        className="roles-accordion_controllers-menu"
        data-testid={`roles-accordion_controllers-menu-${roleId}`}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={handleCloseMenu}>
          <NavLink
            to={{
              pathname: `${Paths.DASHBOARD}/roles/${roleId}/edit`,
            }}
            className="role-menu-item"
            data-testid={`role-menu-option-change-${roleId}`}
          >
            Change
          </NavLink>
        </MenuItem>
        {hasPermissionForDeleteRole && (
          <MenuItem onClick={handleRemoveOption}>
            <div className="role-menu-item" data-testid={`role-menu-option-remove-${roleId}`}>
              Delete
            </div>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};
export { RolesPageAccordionControllersMenu };
